import React from "react";
import styles from "../../pricingHeader/PricingHeader.module.scss";
import { Table, TableHead } from "@material-ui/core";
import Item from "../../../../../shared/item/Item";
import CheckBox from "../../../../../shared/checkBox/CheckBox";
import SortingIcon from "../../../../../shared/sortingIcon/SortingIcon";
import {
  CheckBoxTableCellHeader,
  NonEditTableHeader,
  PermissionHeader,
  SpecsTableHeader,
  WarningTableCell,
} from "../../../../../shared/pricing/dealerFees/TableComponents";

const DealerFeesHeader = (props) => {
  const checkboxes = true;

  const sortHidden =
    props.editEnabled.deliveryFee ||
    props.editEnabled.numberPlates ||
    props.editEnabled.firstRegFee ||
    props.editEnabled.additionalFees;

  return (
    <div className={styles.rowBorder}>
      <Table>
        <TableHead>
          <WarningTableCell />
          {checkboxes && (
            <CheckBoxTableCellHeader className={styles.rowItem}>
              <CheckBox
                className="toggleAllCheckbox"
                id="toggleAllCheckbox"
                checked={false}
                isDisabled={props.isDisabled}
              />
            </CheckBoxTableCellHeader>
          )}
          <SpecsTableHeader
            onClick={() => !sortHidden && props.onClick("specs")}
          >
            <div className={styles.specsHeaderWrap}>
              <Item value={props.t("DealerFees.specs")} />
              <span className={styles.sorting}>
                <SortingIcon
                  currentKey="specs"
                  hide={sortHidden}
                  sortKey={props.sortKey}
                  sortDirection={props.sortDirection}
                />
              </span>
            </div>
          </SpecsTableHeader>
          <NonEditTableHeader
            onClick={() =>
              Array.isArray(props.catalogIds) &&
              props.catalogIds.length > 1 &&
              props.onClick("year")
            }
          >
            <div className={styles.headerWrap}>
              <Item
                className={styles.maxWidth}
                value={props.t("DealerFees.year")}
              />
              <span className={styles.sorting}>
                <SortingIcon
                  currentKey="year"
                  hide={
                    !(
                      Array.isArray(props.catalogIds) &&
                      props.catalogIds.length > 1
                    )
                  }
                  sortKey={props.sortKey}
                  sortDirection={props.sortDirection}
                />
              </span>
            </div>
          </NonEditTableHeader>
          {props.fees &&
            props.fees.map((fee) => {
              return fee.isEditable ? (
                <PermissionHeader
                  {...props}
                  key={fee.key}
                  condition={!props.user.readOnly && props.editFlags[fee.key]}
                  editEnabled={props.editEnabled[fee.key]}
                  headerTestId="feesUpdateHeader"
                  headerText={props.t(fee.name)}
                  cancelTestId={"cancel" + fee.key}
                  confirmTestId={"confirm" + fee.key}
                  cancelChanges={() => {
                    props.cancelUpdate(fee.key);
                  }}
                  editRecords={() => {
                    props.updateEditFlags(fee.key);
                  }}
                  editTestId={"edit" + fee.key}
                  bodyText={props.t(fee.name)}
                  noRenderText={props.t(fee.name)}
                />
              ) : (
                <NonEditTableHeader onClick={() => props.onClick(fee.key)}>
                  <div className={styles.headerWrap}>
                    <Item
                      className={styles.maxWidth}
                      value={props.t(fee.name)}
                    />
                    <span className={styles.sorting}>
                      <SortingIcon
                        currentKey={fee.key}
                        hide={sortHidden}
                        sortKey={props.sortKey}
                        sortDirection={props.sortDirection}
                      />
                    </span>
                  </div>
                </NonEditTableHeader>
              );
            })}
        </TableHead>
      </Table>
    </div>
  );
};

export default DealerFeesHeader;
